import React, {Component} from 'react'
import './MethodModule.sass'
import FormMachine from '../../FormMachine/FormMachine'


class MethodModule extends Component {
  constructor(props) {
    super(props)
    this.state = {
      input2: JSON.parse(localStorage.getItem('InputParams2')),
      maxPage: 2,
      minPage: 0,
      currentPage: 0,
      list: [
        {machine: '3П732Ф1', length: 1250, width: 320, speed: 21, maxMinutes: 35, power: 22},
        {machine: '3Д732Ф1', length: 800, width: 320, speed: 22, maxMinutes: 35, power: 22},
        {machine: '3П733Ф1', length: 1000, width: 400, speed: 22, maxMinutes: 45, power: 22},
        {machine: '3П722Ф2', length: 1250, width: 320, speed: 35, maxMinutes: 35, power: 15},
      ]
    }
  }


  render() {

    if (!this.state.input2 || this.state.input2.typePol === 'периферией круга') {

      const list3 = this.state.list[3]

      return (
        <FormMachine
          machine={list3.machine}
          length={list3.length}
          width={list3.width}
          speed={list3.speed}
          maxMinutes={list3.maxMinutes}
          unenableButtons={true}
        />
      )


    } else if (this.state.input2.typePol === 'торцем круга') {


      const nextPage = () => {
        this.setState({ currentPage: this.state.currentPage + 1 })

        if (this.state.currentPage >= this.state.maxPage) {
          this.setState({
            currentPage: 0
          })
        }
      }

      const prevPage = () => {
        this.setState({
          currentPage: this.state.currentPage - 1
        })

        if (this.state.currentPage <= this.state.minPage) {
          this.setState({
            currentPage: 2
          })
        }
      }

      console.log(this.state.currentPage)


      if (this.state.currentPage === 0) {

        const list0 = this.state.list[0]

        return (

          <FormMachine
            machine={list0.machine}
            length={list0.length}
            width={list0.width}
            speed={list0.speed}
            maxMinutes={list0.maxMinutes}
            firstNext={nextPage}
            prevPage={prevPage}
          />

        )

      } else if (this.state.currentPage === 1) {

        const list1 = this.state.list[1]

        return (

          <FormMachine
            machine={list1.machine}
            length={list1.length}
            width={list1.width}
            speed={list1.speed}
            maxMinutes={list1.maxMinutes}
            firstNext={nextPage}
            prevPage={prevPage}
          />

        )

      } else if (this.state.currentPage === 2) {

        const list2 = this.state.list[2]

        return (

          <FormMachine
            machine={list2.machine}
            length={list2.length}
            width={list2.width}
            speed={list2.speed}
            maxMinutes={list2.maxMinutes}
            firstNext={nextPage}
            prevPage={prevPage}
          />

        )

      }


    }

  }


}

export default MethodModule